var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('LeftMenu',{attrs:{"active":"VideoSurveillance","warning-total":_vm.warningTotal}}),_c('div',{staticClass:"video-con"},[(_vm.token && _vm.type === 0)?_c('video-container',{attrs:{"info":_vm.info,"token":_vm.token}}):_vm._e(),(_vm.token && _vm.type === 1)?_c('video-da-hua',{attrs:{"info":_vm.info}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }